import axios from "axios";
const baseURL = import.meta.env.VITE_PUBLIC_BACKEND_DEV_BASE_URL

const axiosInstance = axios.create({
  baseURL: baseURL,
  withCredentials: true,
});


axiosInstance.interceptors.request.use((config) => {
  const tokenString = localStorage.getItem("admin_accesstoken");

  if (tokenString) {
    try {
      const parsed = JSON.parse(tokenString);
      const token = parsed?.token;

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (e) {
      console.error("Invalid token in localStorage", e);
    }
  }

  return config;
});

export default axiosInstance;

